import React, { useState, useEffect } from 'react';
import { Users, UserPlus, Check, Crown, Shield,  Clock, Home, Phone } from 'lucide-react';
import WhatsAppIcon from '../components/WhatsAppIcon';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Packages = () => {
  const [showAllFeatures, setShowAllFeatures] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [hoveredPackage, setHoveredPackage] = useState(null);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const whatsappUrl = "https://wa.me/966115115945";

  const packages = [
    {
      id: 1,
      name: "الباقة الفضية",
      price: "29,000",
      priceLabel: "ريال/سنوي",
      headerColor: "bg-gradient-to-r from-[#0a3a23] to-[#0a3a23]",
      features: [
        "تقديم (18) استشارة قانونية شفوية أو كتابية",
        "صياغة وتدقيق العقود بكافة أنواعها (10 عقود)",
        "تخفيض 15% على خدمات التوثيق",
        "إدارة 3 قضايا عمالية",
        "صياغة الخطابات القانونية الموجهة للعملاء، المنشأة ودراسة الخطابات الجوابية والردود (20 خطابًا)",
        "خدمات الهيئة السعودية للملكية الفكرية (6 خدمات)",
        "تأسيس المنشآت (3)",
        "إدارة 5 قضايا عمالية",
        "إصدار التراخيص لممارسة الأعمال التجارية"
      ],
      description: "للمؤسسات الكبيرة التي تتطلب حماية قانونية متقدمة"
    },
    {
      id: 2,
      name: "الباقة الذهبية",
      price: "49,000",
      priceLabel: "ريال/سنوي",
      headerColor: "bg-gradient-to-r from-[#0a3a23] to-[#0a3a23]",
      features: [
        "تقديم (10) استشارات قانونية شفوية أو كتابية",
        "صياغة وتدقيق العقود (4 عقود)",
        "تخفيض 15% على خدمات التوثيق",
        "إدارة قضيتين عمالية",
        "صياغة الخطابات القانونية الموجهة للعملاء، المنشأة ودراسة الخطابات الجوابية والردود (10 خطابات)",
        "خدمات الهيئة السعودية للملكية الفكرية (3 خدمات)",
        "تأسيس المنشآت وتحويلها وإندماجها (منشأة واحدة)",
        "إدارة 3 قضايا عمالية",
        "إصدار التراخيص لممارسة الأعمال التجارية (8 تراخيص)",
        "مزايا الباقة صالحة لمدة سنة ميلادية (تبدأ من تاريخ شراء الباقة)"
      ],
      description: "للشركات المتوسطة التي تحتاج دعم قانوني شامل"
    },
    {
      id: 3,
      name: "الباقة الماسية",
      price: "109,000",
      priceLabel: "ريال/سنوي",
      headerColor: "bg-gradient-to-r from-[#0a3a23] to-[#0a3a23]",
      features: [
        "تقديم (6) استشارات قانونية شفوية أو كتابية",
        "صياغة وتدقيق العقود (2 عقود)",
        "تخفيض 15% على خدمات التوثيق",
        "إدارة قضية عمالية واحدة",
        "سعر مميز على التوكيل في المرافعة والمدافعة بالقضايا العامة",
        "صياغة 5 خطابات للموارد البشرية (إنذار، فصل، إنهاء فترة التجربة)",
        "التحقيق الداخلي في مخالفات الموظفين (عدد 2)",
        "مزايا الباقة صالحة لمدة سنة ميلادية (تبدأ من تاريخ شراء الباقة)"
      ],
      description: "مثالية للشركات الناشئة ورواد الأعمال"
    },
    {
      id: 4,
      name: "الباقة المرنة",
      price: "مخصصة",
      priceLabel: "حسب الطلب",
      headerColor: "bg-[#0a3a23]",
      features: [
        "تصمم نموذج الباقة المرنة خصيصاً لتلبية احتياجات الشركات الكبيرة",
        "يشاركك في صياغتها فريقنا من نخبة المستشارين الخبراء لدينا",
        "مساعدتك على الحصول على الباقة التي تناسب حجم أعمالك وميزانيتك",
        "خدمات قانونية حصرية ومتكاملة مصممة خصيصاً لشركتك",
        "مرونة في اختيار الخدمات والكميات حسب احتياجاتك",
        "دعم قانوني متواصل على مدار العام"
      ],
      description: "حلول مصممة خصيصاً للشركات الكبرى التي تحتاج خدمات قانونية حصرية ومتكاملة"
    }
  ];



  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0a3a23]/10 via-white to-[#0a3a23]/5" dir="rtl">
      
      {/* Header */}
      <Header />
      
      {/* Hero Section */}
      <div className="relative bg-gradient-to-br from-[#0a3a23] via-[#0a3a23] to-[#0a3a23] py-12 sm:py-24 overflow-hidden mt-20">
        {/* Background Pattern */}
        <div className="absolute inset-0 bg-black opacity-40"></div>
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='7' cy='7' r='5'/%3E%3Ccircle cx='53' cy='7' r='5'/%3E%3Ccircle cx='30' cy='30' r='5'/%3E%3Ccircle cx='7' cy='53' r='5'/%3E%3Ccircle cx='53' cy='53' r='5'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
        
        <div className="relative z-10 max-w-6xl mx-auto px-4 sm:px-6 text-center text-white">
          <div 
            className={`transform transition-all duration-1500 ${
              isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
            }`}
          >
            <div className="inline-flex items-center gap-2 sm:gap-3 bg-white/90 backdrop-blur-lg border border-white/20 rounded-full px-4 sm:px-6 py-2 sm:py-3 mb-8 sm:mb-12">
              <Crown className="w-4 h-4 sm:w-6 sm:h-6 text-[#0a3a23]" />
              <span className="text-[#0a3a23] font-bold text-sm sm:text-base">الباقات القانونية المتخصصة</span>
            </div>
            
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-7xl font-bold mb-8 sm:mb-12 leading-tight drop-shadow-lg">
              اختر الباقة التي 
              <span className="text-white block mt-2 sm:mt-4">
                تناسب أعمالك
              </span>
            </h1>
            
            <p className="text-sm sm:text-base md:text-xl lg:text-2xl text-white max-w-3xl sm:max-w-4xl mx-auto leading-relaxed mb-12 sm:mb-16 px-4 font-medium drop-shadow-lg">
              حلول قانونية شاملة ومصممة خصيصاً لتلبية احتياجات شركتك ومؤسستك مع ضمان أعلى مستويات الحماية القانونية
            </p>

            {/* Call to Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center items-center">
              <a
                href="#packages"
                className="inline-flex items-center gap-2 sm:gap-3 bg-[#0a3a23] hover:bg-[#0a3a23]/90 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg transition-all duration-300 shadow-lg hover:shadow-xl w-full sm:w-auto justify-center"
              >
                <Crown className="w-4 h-4 sm:w-6 sm:h-6" />
                استكشف الباقات
              </a>
              
              <a
                href={whatsappUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 sm:gap-3 bg-white/90 backdrop-blur-lg border-2 border-white text-[#0a3a23] px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:bg-white transition-all duration-300 w-full sm:w-auto justify-center shadow-xl hover:shadow-2xl"
              >
                <WhatsAppIcon className="w-4 h-4 sm:w-6 sm:h-6" />
                تواصل معنا
              </a>
            </div>
          </div>
        </div>
      </div>



      {/* Packages Section */}
      <div id="packages" className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            باقاتنا القانونية المتخصصة
          </h2>
          <p className="text-sm sm:text-base md:text-xl text-gray-600 max-w-2xl sm:max-w-3xl mx-auto px-4">
            اختر الباقة المناسبة لحجم أعمالك واحتياجاتك القانونية
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 sm:gap-6 mb-8 sm:mb-12">
          {packages.map((pkg, index) => (
            <div
              key={pkg.id}
              className="relative group flex flex-col"
            >
              {/* Package Card */}
              <div className="bg-white rounded-xl sm:rounded-2xl shadow-2xl overflow-hidden border border-gray-100 flex flex-col h-full">
                {/* Header with dark background */}
                <div className={`${pkg.headerColor} p-4 sm:p-6 text-white relative overflow-hidden`}>
                  <div className="text-center">
                    <h3 className="text-lg sm:text-xl font-bold">{pkg.name}</h3>
                  </div>
                </div>

                {/* Features */}
                <div className="p-4 sm:p-6 flex flex-col flex-grow">
                  <p className="text-gray-600 text-xs sm:text-sm mb-3 sm:mb-4 text-center">{pkg.description}</p>
                  <div className="space-y-2 sm:space-y-3 mb-4 sm:mb-6 flex-grow">
                    {pkg.features.slice(0, showAllFeatures ? pkg.features.length : 3).map((feature, idx) => (
                      <div key={idx} className="flex items-start gap-2">
                        <Check className="w-3 h-3 sm:w-4 sm:h-4 text-[#0a3a23] mt-1 flex-shrink-0" />
                        <span className="text-gray-700 text-xs sm:text-sm leading-relaxed">{feature}</span>
                      </div>
                    ))}
                  </div>

                  {/* Show More/Less */}
                  {pkg.features.length > 3 && (
                    <button
                      onClick={() => setShowAllFeatures(!showAllFeatures)}
                      className="text-[#0a3a23] hover:text-[#0a3a23]/80 font-bold mb-3 sm:mb-4 text-xs sm:text-sm transition-colors cursor-pointer border-b border-[#0a3a23]/30 hover:border-[#0a3a23] pb-1"
                    >
                      {showAllFeatures ? 'عرض أقل' : `المزيد (${pkg.features.length - 3}+)`}
                    </button>
                  )}

                  {/* Action Button */}
                  <button
                    onClick={() => {
                      const message = `أريد طلب عرض سعر لـ ${pkg.name}`;
                      window.open(`${whatsappUrl}?text=${encodeURIComponent(message)}`, '_blank');
                    }}
                    className={`w-full inline-flex items-center justify-center gap-2 ${pkg.headerColor} text-white px-3 sm:px-4 py-3 sm:py-4 rounded-lg sm:rounded-xl font-bold text-xs sm:text-sm hover:shadow-xl transition-all duration-300 cursor-pointer shadow-lg border-2 border-transparent hover:border-white/20 mt-auto`}
                  >
                    <WhatsAppIcon className="w-3 h-3 sm:w-4 sm:h-4" />
                    طلب عرض سعر
                  </button>
                </div>
              </div>


            </div>
          ))}
        </div>


      </div>

      {/* Why Choose Us Section */}
      <div className="bg-gray-100 py-12 sm:py-20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-8 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">لماذا تختار باقاتنا القانونية؟</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
            <div className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg text-center group hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <Shield className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">حماية شاملة</h3>
              <p className="text-sm sm:text-base text-gray-600">حماية قانونية متكاملة لجميع جوانب أعمالك مع ضمان الامتثال للأنظمة</p>
            </div>
            
            <div className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg text-center group hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <Users className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">فريق متخصص</h3>
              <p className="text-sm sm:text-base text-gray-600">فريق من المحامين المعتمدين والمتخصصين في مختلف المجالات القانونية</p>
            </div>
            
            <div className="bg-white p-6 sm:p-8 rounded-xl sm:rounded-2xl shadow-lg text-center group hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] rounded-full flex items-center justify-center mx-auto mb-4 sm:mb-6">
                <Clock className="w-6 h-6 sm:w-8 sm:h-8 text-white" />
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 sm:mb-4">دعم مستمر</h3>
              <p className="text-sm sm:text-base text-gray-600">متابعة مستمرة ودعم على مدار الساعة لضمان سير أعمالك بسلاسة</p>
            </div>
          </div>
        </div>
      </div>





      {/* Floating Contact Buttons */}
      <a
        href="tel:920033053"
        className="fixed bottom-20 sm:bottom-28 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <Phone className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Floating WhatsApp Button */}
      <a
        href={`${whatsappUrl}?text=أريد استشارة في الباقات القانونية`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 sm:bottom-6 left-4 sm:left-6 bg-gradient-to-r from-[#0a3a23] to-[#0a3a23] text-white p-3 sm:p-4 rounded-full shadow-2xl hover:shadow-[#0a3a23]/25 transition-all duration-300 z-50 hover:scale-110"
      >
        <WhatsAppIcon className="w-5 h-5 sm:w-6 sm:h-6" />
      </a>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Packages; 
